var exports = {
  "O": "x804f0401--dd5655--info-button",
};

module.exports = exports;
